import { AppContexts } from './app.contexts'
import { env } from 'utils'
import reportWebVitals from './report-web-vitals'
import ReactDOM from 'react-dom/client'
import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'
import * as Sentry from '@sentry/react'
import './index.scss'

if(env().ENVIRONMENT !== 'local'){
    Sentry.init({
        dsn: 'https://4839c111724d264143a27beaa887109c@o4509402482016256.ingest.us.sentry.io/4509405981966336',
        sendDefaultPii: true
    })
    Sentry.setTag('ENVIRONMENT', env().ENVIRONMENT)
}

//start week from Monday:
dayjs.extend(updateLocale)
dayjs.updateLocale('en', { weekStart: 1 })

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
)

root.render(<AppContexts/>)

reportWebVitals()
